
"use strict";

var React = require('react');
var Immutable = require('immutable');
var classNames = require('classnames');
var EMPTY_LIST = Immutable.List();

class ProgramGroupItem extends React.Component {
	shouldComponentUpdate(nextProps) {
		const { model, className, showCategories, ...other } = this.props;
		if(!Immutable.is(model, nextProps.model)) { return true; }
		if(showCategories !== nextProps.showCategories) { return true; }
		if(className !== nextProps.className) { return true; }
		return false;
	}
	
	render() {

		const { model, className, showCategories, ...other } = this.props;

		if(!model || model.isEmpty()) {
			return false;
		}

		var cn;
		if(showCategories) {
			cn = classNames(
				className,
				'svtse_program-list-ao__item',
				model.get('categories', EMPTY_LIST).map(
					function(category){
						return 'svtse_program-list-ao__item--' + category;
					}
				).join(' ')
			);
		} else {
			cn = classNames(className, 'svtse_program-list-ao__item');
		}

		return (
			<li className="svtse_program-list-ao__listitem" {...other}>
				<a href={model.get('url')} className={cn}>{model.get('title')}</a>
			</li>
		);
	}
}

ProgramGroupItem.propTypes = {
		model: React.PropTypes.instanceOf(Immutable.Map).isRequired
};

module.exports = ProgramGroupItem;



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/ProgramGroupItem.jsx
 **/